var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var navigateEvent = function (route, action, data) { return (__assign({ purpose: 'navigate', route: route,
    action: action }, data)); };
var responseForNavigate = function (messageData) {
    // Build the response message for a navigate.
    var _a = messageData.data, webapp_id = _a.webapp_id, route = _a.route, params = _a.params, context = _a.context, transition = _a.transition;
    // If we are passed a webapp_id this route is navigating to an external web app.
    var result = webapp_id ? "external://" + webapp_id + "/" + route : route;
    var event = navigateEvent(result, transition, { params: params, context: context });
    return event;
};
var navigationMiddleware = function (dispatch) { return function (next, done) { return function (message) {
    if (message.domain !== 'iwa' || message.eventType !== 'navigate') {
        return next(message);
    }
    dispatch(responseForNavigate(message.data));
    done();
}; }; };
export default navigationMiddleware;
//# sourceMappingURL=navigation.js.map